<div #ngContentRef><ng-content></ng-content></div>
<div *ngIf="!ngContentRef.hasChildNodes()" class="fc-responsive-ag-grid-desktop-wrapper">
    <table>
        <thead>
        <tr>
            <th *ngIf="gridOptions.multipleSelect" class="column-checkbox">
                <label class="checkbox-container" [ngClass]="{'disabled': gridOptions.isCheckAllDisabled}" *ngIf="!gridOptions.isCheckAllHidden">
                    <input class="checkbox-input" type="checkbox"
                           [checked]="gridOptions.isAllSelected && gridOptions.isAllSelected()"
                           (click)="gridOptions.toggleAll && gridOptions.toggleAll()">
                    <span class="checkmark"
                          [ngClass]="{'all-checked': gridOptions.isAllSelected && gridOptions.isAllSelected()}"></span>
                </label>
            </th>
            <th *ngFor="let column of gridOptions.columnDefs"
                [ngClass]="[column.colClass || 'column-'+column.field]"
                [ngStyle]="{'width.px': column.width }"
                (click)="gridOptions.sortChange && gridOptions.sortChange(column)">
                <span>
                    {{ column.label }}
                    <span class="order-up" *ngIf="gridOptions.enableSort && gridOptions.gridState && gridOptions.gridState.order==='ASC' && gridOptions.gridState.orderBy === column.field"></span>
                    <span class="order-down" *ngIf="gridOptions.enableSort && gridOptions.gridState && gridOptions.gridState.order==='DESC' && gridOptions.gridState.orderBy === column.field"></span>
                </span>
            </th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let item of gridOptions.data">
            <tr [ngClass]="{'selected': item.selected}"
                (click)="gridOptions.rowClick && gridOptions.rowClick($event, item, gridOptions)"
            >
                <td *ngIf="gridOptions.multipleSelect" class="column-checkbox">
                    <label class="checkbox-container" *ngIf="!item._hideCheckbox" [ngClass]="{'disabled': item.disabled}">
                        <input class="checkbox-input" type="checkbox"
                               [checked]="item.selected"
                               (click)="gridOptions.rowClick && gridOptions.rowClick($event, item, gridOptions);$event.stopPropagation()">
                        <span class="checkmark" [ngClass]="{'item-checked': item.selected}" (click)="$event.stopPropagation()"></span>
                    </label>
                </td>
                <td *ngFor="let column of gridOptions.columnDefs"
                    [ngClass]="[column.colClass || 'column-'+column.field]"
                    (click)="gridOptions.cellClick && gridOptions.cellClick($event, item, column, gridOptions)">
                    <div *ngIf="column.cellTemplate">
                        <ng-container *ngTemplateOutlet="column.cellTemplate; context: { value: column.field ? item[column.field] : null, row: item}"></ng-container>
                    </div>
                    <div *ngIf="gridOptions.renderCell">
                        <span *ngIf="column.enableHtml" [innerHTML]="gridOptions.renderCell(item, column, gridOptions)"></span>
                        <span *ngIf="!column.enableHtml">{{ gridOptions.renderCell(item, column, gridOptions) }}</span>
                    </div>
                </td>
            </tr>
            <ng-container *ngIf="gridOptions.isExpand && gridOptions.rowDetailsTemplate && item.expanded">
                <ng-container *ngTemplateOutlet="gridOptions.rowDetailsTemplate; context: { value: item, row: item }"></ng-container>
            </ng-container>
        </ng-container>
        <tr *ngFor="let extraRow of (gridOptions.getNumberExtraRows && gridOptions.getNumberExtraRows())">
            <td *ngFor="let column of gridOptions.columnDefs">
            </td>
            <td *ngIf="gridOptions.multipleSelect"></td>
        </tr>
        </tbody>
    </table>
</div>